import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Card, Button, ListGroup, ListGroupItem } from "react-bootstrap";
import { loadStripe } from '@stripe/stripe-js'
import { useEffect, useState } from 'react'
import { API, Auth } from 'aws-amplify';
import { useNavigate } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
const SubscriptionCard = ({ id, title, price, features, currentPlan }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const stripeurl = 'https://g6glhobkn3.execute-api.ca-central-1.amazonaws.com/top'

    // let currentPlan= localStorage.getItem('user_account_type')
    let currentPlanId = ''
    if (currentPlan === 'single')
        currentPlanId = '2'
    else if (currentPlan === 'corporate')
        currentPlanId = '3'
    else
        currentPlanId = '1'

    const navigate = useNavigate();
    const createCustomer = async (user) => {
        const email = user.attributes.email;

        console.log(email)

        let customer_info = { email: email }
        console.log(customer_info)
        const body = { customer_info };
        return fetch(stripeurl + '/create-user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': user.signInUserSession.idToken.jwtToken
            },
            body: JSON.stringify(body)
        })
        // .then(response => response.json())
        // .then(response => {
        //     console.log(response.id);

        //     return response.id
        // })
        // .catch((err) => {
        //     console.log(err)
        // });
    }

    const handlePayment = async (id) => {

        if ((currentPlan === 'single' || currentPlan === 'corporate') && id === '1') {
            navigate("/cancel");
            return;
        }
        const stripe = await loadStripe('pk_live_51LHY9LINLuNBAuS2ZSXAcDA3kjJx7An8R5eDEewAc9Xmq5pAbxkdPXN7OaHg4eCEGP3UyQTyRvBGCjQ626oif0I700tcWE2Oor')

        const user = await Auth.currentAuthenticatedUser();
        const customer_email = user.attributes.email;


        let product = {}
        if (id === '2') {
            product = {
                price: 'price_1Mm5SdINLuNBAuS2DHTVkDUw', //test priceId'price_1MpkozINLuNBAuS2AalIC8ol'
                quantity: 1
            }
        }
        else if (id === '3') {
            product = {
                price: 'price_1Mm5WcINLuNBAuS2mhOag9np',
                quantity: 1
            }
        }


        createCustomer(user)
            .then(customer_response => customer_response.json())
            .then(customer_response => {
                const customer_id = customer_response.id;

                console.log("CUSTOMER ID " + customer_id)

                const body = {
                    product: product,
                    customer: {
                        customer_id: customer_id,
                        customer_email: customer_email
                    }

                };

                fetch(stripeurl + '/create-checkout-session', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body)
                }
                )
                    .then(response => response.json())
                    .then(response => {
                        console.log("SESSION:" + response.id)
                        try {
                            setErrorMessage('');
                            const error = stripe.redirectToCheckout({
                                sessionId: response.id,
                                // lineItems: [
                                //     product
                                // ],
                                // mode: 'subscription',
                                // successUrl: 'http://localhost:3000',
                                // cancelUrl: 'http://localhost:3000/cancel',
                                // //customer_email: user.email,
                            })
                            if (error) {
                                switch (error.type) {
                                    case 'payment_intent_authentication_failure':
                                        // Handle authentication failures
                                        console.log(error.message);
                                        setErrorMessage(error.message)
                                        break;
                                    case 'payment_intent_invalid_parameter':
                                        // Handle invalid parameters
                                        console.log(error.message);
                                        setErrorMessage(error.message)
                                        break;
                                    case 'payment_intent_unexpected_error':
                                        // Handle unexpected errors
                                        console.log(error.message);
                                        setErrorMessage(error.message)
                                        break;
                                    // Handle other error types here
                                    default:
                                        console.log(error.message);
                                }
                            }

                        } catch (err) {
                            console.log('Error redirecting to Stripe checkout:', err);
                        }
                    })

            })

    }

    return (
        <Card bg="light" text="dark" className='mb-3 flex-fill' >
            <Card.Header>
                <h2 className="text-center">{title}</h2>
            </Card.Header>
            <Card.Body>
                <Card.Title className="text-center"><b>{price}</b></Card.Title>
                <ListGroup>
                    {features.map((feature, index) => (
                        <ListGroupItem key={index}>
                            <i className="bi bi-check text-success me-2"></i>
                            {feature}
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </Card.Body>
            <Card.Footer>
                <Button variant="primary" className="w-100" onClick={() => handlePayment(id)} disabled={currentPlanId === id}>
                    <b>Buy</b>
                </Button>
            </Card.Footer>
        </Card>
    );

}

const Subscription = (props) => {
    const [typeOfAccount, settypeOfAccount] = useState("");
    const [statusSubscription, setstatusSubscription] = useState("");

    useEffect(() => {
        const token = props.user.signInUserSession.idToken.jwtToken
        const requestInfo = { headers: { Authorization: token } }
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
            .then(response => {
                //localStorage.setItem('user_account_type', response.user_account_type)
                settypeOfAccount(response.user_account_type);
                setstatusSubscription(response.status_subscription)
                console.log(response.status_subscription)
                console.log(response.user_account_type)
            })

            .then(error => {
                console.log(error)
            })

    }, []);


    const plans = [
        {
            id: '1',
            title: "Free Plan",
            price: "$0/month",
            features: ["Upload max. 10 documents", "Send 50 requests/month"],
            currentPlan: typeOfAccount
        },
        {
            id: '2',
            title: "Single Plan",
            price: "$99/month",
            features: [
                "Unlimited access to all resources",
            ],
            currentPlan: typeOfAccount
        },
        {
            id: '3',
            title: "Corporate Plan",
            price: "$250/month",
            features: [
                "Get four additional user accounts",
                "Unlimited Access to all resources for all 5 users(main corporate user included)",
            ],
            currentPlan: typeOfAccount
        },
    ];

    return (
        <Container>
            <br />
            {!statusSubscription && (
            <h1 style={{ textAlign: 'center' }}>Pricing Plans</h1>
            )}
            <br />
            {!statusSubscription && (
                <Row className="justify-content-center m-5" id='subscription-cards'>
                    {plans.map((plan, index) => (
                        <Col className='subscription-card d-flex' key={index} style={{ margin: "0 1em" }}>
                            <SubscriptionCard {...plan} />
                        </Col>
                    ))}
                </Row>
            )}
            {statusSubscription && (
                <Row>
                    <Alert key="danger" variant="danger">
                        Sorry, you already requested for cancellation on your subscription.
                    </Alert>
                </Row>
            )}
        </Container>
    );
};

export default Subscription;
